/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svcat_BackendInputs */

const en_svcat_backend = /** @type {(inputs: Svcat_BackendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backend`)
};

const ar_svcat_backend = /** @type {(inputs: Svcat_BackendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`باك إند`)
};

const bn_svcat_backend = /** @type {(inputs: Svcat_BackendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ব্যাকএন্ড`)
};

const de_svcat_backend = /** @type {(inputs: Svcat_BackendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backend`)
};

const es_svcat_backend = /** @type {(inputs: Svcat_BackendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backend`)
};

const fr_svcat_backend = /** @type {(inputs: Svcat_BackendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back-end`)
};

const pt_svcat_backend = /** @type {(inputs: Svcat_BackendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back-end`)
};

const zh_svcat_backend = /** @type {(inputs: Svcat_BackendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`后端`)
};

const tr_svcat_backend = /** @type {(inputs: Svcat_BackendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backend`)
};

const ru_svcat_backend = /** @type {(inputs: Svcat_BackendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backend`)
};

const pl_svcat_backend = /** @type {(inputs: Svcat_BackendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backend`)
};

/**
* | output |
* | --- |
* | "Backend" |
*
* @param {Svcat_BackendInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svcat_backend = /** @type {((inputs?: Svcat_BackendInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svcat_BackendInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svcat_backend(inputs)
	if (locale === "bn") return bn_svcat_backend(inputs)
	if (locale === "de") return de_svcat_backend(inputs)
	if (locale === "es") return es_svcat_backend(inputs)
	if (locale === "fr") return fr_svcat_backend(inputs)
	if (locale === "pt") return pt_svcat_backend(inputs)
	if (locale === "zh") return zh_svcat_backend(inputs)
	if (locale === "tr") return tr_svcat_backend(inputs)
	if (locale === "ru") return ru_svcat_backend(inputs)
	if (locale === "pl") return pl_svcat_backend(inputs)
	return en_svcat_backend(inputs)
});